<app-base-post
  [post]="post"
  [isLoading]="isLoading"
  [hideFeaturedImage]="false"
></app-base-post>
